import React from 'react';
import classes from "./BookingConfirmation.module.css"
import NavBar from '../NavBar/NavBar';
import { useBooking } from '../../store/bookingStore';
import { parseLocalDateString } from '../../util/parseLocalDate';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import { useNavigate } from 'react-router-dom';
import { buildCoarseLocationText } from '../../util/locationPrivacy';

const BookingConfirmation = ({ studio, setShowBookingProcedure }) => {
    const navigate = useNavigate();
    const { bookingData, clearBookingData } = useBooking();
    const parsedDate = parseLocalDateString(bookingData.date);
    const date = parsedDate ? format(parsedDate, "EEEE, d. MMMM, yyyy", {
        locale: de
    }) : '';

    const navigateToBooking = async () => {
        const bookingId = bookingData.id;
        await clickedRefreshButton();

        navigate(`/bookings/details/${bookingId}`);
    }

    const clickedRefreshButton = () => {
        clearBookingData();
        setShowBookingProcedure(false);
    };

return (
    <div className={classes.bookingConfirmation}>
        <NavBar fromBooking={true}/>
        <div className={classes.bookingConfirmationContent}>
            <div className={classes.bookingConfirmationIcon}>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M31.6132 2.59646L9.6969 23.4423L9.69648 23.4419L9.69441 23.4439L0.398438 13.948L2.49103 11.8994L9.76814 19.3331L29.595 0.474609L31.6132 2.59646Z" fill="white"/>
                </svg>
            </div>
            <h1 className={`${classes.bookingConfirmationTitle} titleSemibold2`}>Deine Buchung wurde angefragt!</h1>
            <p className={`${classes.bookingConfirmationText} slimRegularSmallText`}>
                {studio.User.firstName} {studio.User.lastName} hat 24 Stunden um deine Anfrage zu bestätigen. 
                Wir schicken dir eine Buchungsbestätigung per E-Mail.
            </p>
            <div className={classes.bookingConfirmationStudioContainer}>
                <div className={classes.bookedStudioContainer}>
                    <div className={classes.bookedStudioImageContainer}>
                        <img src={studio.processedImages[0]} alt="studio" />
                    </div>
                    <div className={classes.bookedStudioTextContainer}>
                        <h2 className={`${classes.bookedStudioTitle} semiboldLarge`}>{studio.StudioName}</h2>
                        <p className={`${classes.bookedStudioText} slimRegularMiddleText`}>
                            {buildCoarseLocationText(studio)}
                        </p>
                        {studio.averageRating && (
                        <div className={classes.ratingContainer}>
                            <p className={`${classes.ratingText} slimRegularSmallText`}>4,8</p>
                            <div className={classes.ratingStarsContainer}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
                                    <g clipPath="url(#clip0_7595_2481)">
                                    <path d="M6.27827 6.10615L6.59908 7.98641L4.17969 6.72102L6.14015 5.30859L6.23372 5.84772L6.27827 6.10615Z" fill="#1D1E1B"/>
                                    <path d="M2.12807 5.84745L2.22163 5.30832L0.265625 3.41469L2.97017 3.0226L4.1821 0.589844L5.39402 3.0226L8.09857 3.41469L1.76271 7.98614L2.12807 5.84745Z" fill="#1D1E1B"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_7595_2481">
                                    <rect width="7.83294" height="7.39629" fill="white" transform="translate(0.265625 0.589844)"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <span className={`${classes.numberOfRatings} slimRegularSmallText`}>
                                (25)
                            </span>
                        </div>
                        )}
                        <h3 className={`${classes.bookingDateAndTime} semiboldSmall`}>
                            Datum und Zeit
                        </h3>
                        <p className={`${classes.bookingDateAndTimeText} slimRegularMiddleText`}>
                            {date}
                        </p>
                        <p className={`${classes.bookingDateAndTimeText} slimRegularMiddleText`}>
                            {bookingData.startTime} - {bookingData.endTime} Uhr
                        </p>
                    </div>
                </div>
                <div className={classes.buttonsContainer}>
                        <button className={`${classes.button} mediumLarge`} onClick={() => {
                            clickedRefreshButton();
                            navigate(`/studio/${studio?.id}`);
                        }}>
                            Zum Studio
                        </button>
                        <button className={`${classes.button} mediumLarge`} onClick={() => {navigateToBooking();}}>
                            Buchung anschauen
                        </button>
                </div>
            </div>
        </div>
    </div>
  );
};

export default BookingConfirmation;
